import React from 'react';
import { Plus, MessageSquare } from 'lucide-react';
import { Button } from '@mantine/core';
export const Sidebar = ({
  conversations,
  setActiveConversation,
  addNewConversation,
  isOpen
}) => {
  if (!isOpen) return null;
  return <div className="w-full sm:w-64 bg-gray-100 h-full overflow-y-auto flex-shrink-0 border-r border-gray-200 md:block absolute md:relative z-10" data-id="element-203">
      <div className="p-3 sm:p-4" data-id="element-204">
        <Button fullWidth className="bg-blue-600 hover:bg-blue-700 mb-3 sm:mb-4 text-xs sm:text-sm" leftSection={<Plus size={16} data-id="element-206" />} onClick={addNewConversation} size="sm" data-id="element-205">
          New Catalog Experience
        </Button>
        <div className="mt-4 sm:mt-6" data-id="element-207">
          <h2 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 sm:mb-3" data-id="element-208">
            Your Catalog Journeys
          </h2>
          <div className="space-y-1 sm:space-y-2" data-id="element-209">
            {conversations.map(conversation => <div key={conversation.id} className={`flex items-center p-2 rounded-lg cursor-pointer text-xs sm:text-sm ${conversation.active ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-200'}`} onClick={() => setActiveConversation(conversation.id)} data-id="element-210">
                <MessageSquare size={16} className="mr-2 flex-shrink-0" data-id="element-211" />
                <span className="truncate" data-id="element-212">{conversation.title}</span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};